import React from 'react';
import { LuTriangleAlert } from 'react-icons/lu';

// Shallow array equality, treating two missing arrays as equal.
const sameKeys = (a, b) => {
  if (a === b) return true;
  if (!Array.isArray(a) || !Array.isArray(b) || a.length !== b.length) return false;
  return a.every((v, i) => Object.is(v, b[i]));
};

export const SectionError = ({ title = 'Cette section n\'a pas pu s\'afficher.' }) => (
  <div role="alert" className="flex items-center gap-3 rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800 dark:border-amber-900/60 dark:bg-amber-950/40 dark:text-amber-200">
    <LuTriangleAlert className="h-4 w-4 flex-shrink-0" aria-hidden />
    <span>{title} Le reste de la page reste utilisable.</span>
  </div>
);

/**
 * Keeps one failing section from taking the page down. `resetKeys` clears a latched
 * error when any entry changes (e.g. a fresh fetch or another tab).
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught an error:', error, info);
  }

  componentDidUpdate(prevProps) {
    if (this.state.error && !sameKeys(prevProps.resetKeys, this.props.resetKeys)) {
      this.setState({ error: null });
    }
  }

  render() {
    if (!this.state.error) return this.props.children;
    const { fallback } = this.props;
    if (typeof fallback === 'function') return fallback(this.state.error);
    return fallback !== undefined ? fallback : <SectionError />;
  }
}

export default ErrorBoundary;
